import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IImageBarProps extends IBaseElementProps {
	images?: IImage[];
}

/**
 * Image Bar
 * @block
 * @icon images-alt
 * @requiresHooks
 */

const ImageBar: React.FC<IImageBarProps> = ({
	images = [],
	className,
	classNames = [],
}) =>
	images?.length > 0 && (
		<div className={className || cn('image-bar', ...classNames)}>
			{images.map((image, index) => (
				<div key={index} className="image-bar__image">
					<Image {...image} />
				</div>
			))}
		</div>
	);

export default ImageBar;
